const queryParams = new URLSearchParams(window.location.search);

export default function enrollmentCode(params) {
  if (!params) {
    return;
  }

  for (const [key, value] of params) {
    const element = document.querySelector(`input[name="${key}"]`);

    if (element) {
      element.value = value;
    }
  }
}

enrollmentCode(queryParams);
